export const Types = {
  CREATE_EXPENSE_TYPE: 'expenseType/CREATE_EXPENSE_TYPE',
  EDIT_EXPENSE_TYPE: 'expenseType/EDIT_EXPENSE_TYPE',
  SET_RESULTS: 'expenseType/SET_RESULTS',
  NEXT_RESULTS: 'expenseType/NEXT_RESULTS',
  SET_PAGE_INFO: 'expenseType/SET_PAGE_INFO',
  SET_ERROR_QUERY: 'expenseType/SET_ERROR_QUERY',
  SET_ERROR_MUTATION: 'expenseType/SET_ERROR_MUTATION',
  SET_SUCCESS_QUERY: 'expenseType/SET_SUCCESS_QUERY',
  SET_SUCCESS_MUTATION: 'expenseType/SET_SUCCESS_MUTATION',
  LOAD_QUERY: 'expenseType/LOAD_QUERY',
  LOAD_MUTATION: 'expenseType/LOAD_MUTATION',
  FETCH_EXPENSE_TYPES: 'expenseType/FETCH_EXPENSE_TYPES',
  RESET_STATE: 'expenseType/RESET_STATE',
  USER_LOGOUT: 'USER_LOGOUT',
};

const initialState = {
  results: [],
  pageInfo: {},
  load_query: false,
  load_mutation: false,
  error_query: {},
  error_mutation: {},
  success_query: {},
  success_mutation: {},
};

export default function expenseType(state = initialState, action) {
  switch (action.type) {
    case Types.SET_RESULTS:
      return { ...state, results: action.results };
    case Types.NEXT_RESULTS:
      return { ...state, results: [...state.results, ...action.results] };
    case Types.SET_PAGE_INFO:
      return { ...state, pageInfo: action.pageInfo };
    case Types.SET_ERROR_QUERY:
      return { ...state, error_query: action.error };
    case Types.SET_ERROR_MUTATION:
      return { ...state, error_mutation: action.error };
    case Types.SET_SUCCESS_QUERY:
      return { ...state, success_query: action.success };
    case Types.SET_SUCCESS_MUTATION:
      return { ...state, success_mutation: action.success };
    case Types.LOAD_QUERY:
      return { ...state, load_query: action.load };
    case Types.LOAD_MUTATION:
      return { ...state, load_mutation: action.load };
    case Types.RESET_STATE:
    case Types.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export function saveExpenseType({ data, edit, success, error }) {
  return {
    type: edit === true ? Types.EDIT_EXPENSE_TYPE : Types.CREATE_EXPENSE_TYPE,
    data,
    success,
    error,
  };
}

export function fetchExpenseTypes({ id }) {
  return {
    type: Types.FETCH_EXPENSE_TYPES,
    id,
  };
}

export function resetState() {
  return {
    type: Types.RESET_STATE,
  };
}
